import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by MCSRCN Community"
      links={[
        {
          key: 'MCSRCN',
          title: 'MCSRCN',
          href: 'https://www.mcspeedrun.cn',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
